import {FR} from "../../i18n/fr";
import i18n from "i18next";
import {useTranslation} from "react-i18next";

let localeLoaded = false;

const useAuthentication = () => {

  if (!localeLoaded) {
    localeLoaded = true;

    Object.keys(FR).forEach(k => i18n.addResourceBundle("fr", k, FR[k]));
  }

  const {t} = useTranslation("authentication");

  return {t};
}

export default useAuthentication;
